import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { ArcanaReadingsPage } from '../features/arcana-readings/page'

export const arcanaReadingsRoute = createRoute({
  path: 'arcana-readings',
  getParentRoute: () => rootRoute,
  validateSearch: (search: Record<string, unknown>): { order?: string } =>
    typeof search.order === 'string' && search.order ? { order: search.order } : {},
  component: ArcanaReadingsPage,
})
